// @ts-nocheck
import * as React from "react";

const InfoLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 4c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm0 12c-.44 0-.8-.36-.8-.8V12c0-.44.36-.8.8-.8.44 0 .8.36.8.8v3.2c0 .44-.36.8-.8.8Zm.8-6.4h-1.6V8h1.6v1.6Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(InfoLine);
